// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export { accessAccountabilityTour } from './access-accountability.js';
export { assessmentsTour } from './assessments.js';
export { auditTrailTour } from './audit-trail.js';
export { classificationTour } from './classification.js';
export { complianceFormsTour } from './compliance-forms.js';
export { connectorsTour } from './connectors.js';
export { consentPropertiesTour } from './consent-properties.js';
export { consentTour } from './consent.js';
export { dashboardTour } from './dashboard.js';
export { dataMappingTour } from './data-mapping.js';
export { dataSubjectsTour } from './data-subjects.js';
export { deletionOrchestrationTour } from './deletion-orchestration.js';
export { discoveryTour } from './discovery.js';
export { governanceTour } from './governance.js';
export { helpCenterTour } from './help-center.js';
export { incidentOpsTour } from './incident-ops.js';
export { incidentsTour } from './incidents.js';
export { localizationTour } from './localization.js';
export { monitoringTour } from './monitoring.js';
export { onboardingTour } from './onboarding.js';
export { organizationsTour } from './organizations.js';
export { partnerWorkspaceTour } from './partner-workspace.js';
export { platformSettingsTour } from './platform-settings.js';
export { privacyScannerTour } from './privacy-scanner.js';
export { programGovernanceTour } from './program-governance.js';
export { rightsRequestsTour } from './rights-requests.js';
export { taskManagementTour } from './task-management.js';
export { vendorRiskTour } from './vendor-risk.js';
// Lazy imports for the ALL_TOUR_SCRIPTS array
import { accessAccountabilityTour } from './access-accountability.js';
import { assessmentsTour } from './assessments.js';
import { auditTrailTour } from './audit-trail.js';
import { classificationTour } from './classification.js';
import { complianceFormsTour } from './compliance-forms.js';
import { connectorsTour } from './connectors.js';
import { consentPropertiesTour } from './consent-properties.js';
import { consentTour } from './consent.js';
import { dashboardTour } from './dashboard.js';
import { dataMappingTour } from './data-mapping.js';
import { dataSubjectsTour } from './data-subjects.js';
import { deletionOrchestrationTour } from './deletion-orchestration.js';
import { discoveryTour } from './discovery.js';
import { governanceTour } from './governance.js';
import { helpCenterTour } from './help-center.js';
import { incidentOpsTour } from './incident-ops.js';
import { incidentsTour } from './incidents.js';
import { localizationTour } from './localization.js';
import { monitoringTour } from './monitoring.js';
import { onboardingTour } from './onboarding.js';
import { organizationsTour } from './organizations.js';
import { partnerWorkspaceTour } from './partner-workspace.js';
import { platformSettingsTour } from './platform-settings.js';
import { privacyScannerTour } from './privacy-scanner.js';
import { programGovernanceTour } from './program-governance.js';
import { rightsRequestsTour } from './rights-requests.js';
import { taskManagementTour } from './task-management.js';
import { vendorRiskTour } from './vendor-risk.js';
/** All 28 tour scripts in display order */
export const ALL_TOUR_SCRIPTS = [
    dashboardTour,
    rightsRequestsTour,
    dataMappingTour,
    dataSubjectsTour,
    governanceTour,
    consentTour,
    assessmentsTour,
    incidentsTour,
    classificationTour,
    monitoringTour,
    localizationTour,
    complianceFormsTour,
    taskManagementTour,
    auditTrailTour,
    incidentOpsTour,
    vendorRiskTour,
    deletionOrchestrationTour,
    discoveryTour,
    connectorsTour,
    consentPropertiesTour,
    programGovernanceTour,
    accessAccountabilityTour,
    privacyScannerTour,
    organizationsTour,
    partnerWorkspaceTour,
    platformSettingsTour,
    onboardingTour,
    helpCenterTour,
];
//# sourceMappingURL=index.js.map